const Bfsg = {
  cfg: {
    presseMeldungen: null
  },

  initBfsg() {
    // #########################################################################
    // Keyboard navigation for articles
    // #########################################################################

    // Use a function to get the latest articles whenever needed
    const getArticles = () => Array.from(document.querySelectorAll('a.boxlink'));

    // Function to initialize keyboard navigation
    const initKeyboardNav = () => {
      const articles = getArticles();

      // If no articles found, try again later
      if (articles.length === 0) {
        setTimeout(initKeyboardNav, 500);
        return;
      }

      articles.forEach(article => {
        article.setAttribute('tabindex', '0'); // Ensure all articles are focusable

        article.addEventListener('keydown', event => {
          // Only handle arrow keys if they're not used with modifier keys
          if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
            return;
          }

          // Get fresh list of articles to handle any DOM changes
          const currentArticles = getArticles();
          const currentIndex = currentArticles.indexOf(event.currentTarget);

          if (event.key === 'ArrowUp' || event.key === 'Up') {
            event.preventDefault(); // Prevent page scrolling

            // Find the previous focusable element
            if (currentIndex > 0) {
              currentArticles[currentIndex - 1].focus();
            }
          } else if (event.key === 'ArrowDown' || event.key === 'Down') {
            event.preventDefault(); // Prevent page scrolling

            // Find the next focusable element
            if (currentIndex < currentArticles.length - 1) {
              currentArticles[currentIndex + 1].focus();
            }
          }
        });
      });
    };

    // Start initialization process
    initKeyboardNav();

    // Also set up a MutationObserver to handle dynamically added content
    const observer = new MutationObserver(mutations => {
      const hasNewArticles = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(
          node => node.querySelectorAll && node.querySelectorAll('a.boxlink').length > 0
        )
      );

      if (hasNewArticles) {
        initKeyboardNav();
      }
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
  },

  /**
   * Initialize.
   */
  init() {
    this.initBfsg();
  }
};

export default Bfsg;
